// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"d85474e1","197":"e4f4143d","395":"891258a1","401":"c1f847b6","496":"57307047","684":"af0294d1","822":"4319e7d9"}[chunkId] + ".chunk.js";
};